import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'
import MenuItem from '../components/MenuItem'

import classNames from 'classnames/bind'
import styles from '../styles/Menu.module.css'
const cx = classNames.bind(styles)

const DoubleDish = ({ data = [] }) => {
  return (
    <Box className={cx('food_list_t2')}>
      {data.map((item) => (
        <MenuItem {...item} isDoubleList key={item.id} />
      ))}
    </Box>
  )
}

DoubleDish.propTypes = {
  data: PropTypes.array,
}

export default DoubleDish
